import React from 'react';

function SkeletonLoader({ type, count = 1 }) {
  const renderProjectCardSkeleton = () => (
    <div className="bg-bg-light rounded-lg shadow-md border border-border-subtle overflow-hidden flex flex-col animate-pulse">
      <div className="w-full h-48 bg-gray-700"></div>
      <div className="p-6 flex flex-col flex-grow">
        <div className="h-6 bg-gray-700 rounded w-3/4 mb-2"></div>
        <div className="h-4 bg-gray-700 rounded w-full mb-2"></div>
        <div className="h-4 bg-gray-700 rounded w-5/6 mb-4"></div>
        <div className="flex flex-wrap gap-2 mt-auto">
          <div className="h-6 bg-gray-700 rounded-full w-1/4"></div>
          <div className="h-6 bg-gray-700 rounded-full w-1/5"></div>
          <div className="h-6 bg-gray-700 rounded-full w-1/6"></div>
        </div>
        <div className="flex justify-center mt-4">
          <div className="h-10 bg-gray-700 rounded-full w-1/2"></div>
        </div>
      </div>
    </div>
  );

  const renderBlogCardSkeleton = () => (
    <div className="bg-gray-800 rounded-lg shadow-lg overflow-hidden border border-border-subtle animate-pulse">
      <div className="w-full h-48 bg-gray-700"></div>
      <div className="p-6">
        <div className="h-6 bg-gray-700 rounded w-3/4 mb-2"></div>
        <div className="h-4 bg-gray-700 rounded w-1/3 mb-4"></div>
        <div className="h-4 bg-gray-700 rounded w-full mb-2"></div>
        <div className="h-4 bg-gray-700 rounded w-5/6 mb-4"></div>
      </div>
    </div>
  );

  const renderRecentBlogListItemSkeleton = () => (
    <li className="pb-4 border-b border-border-subtle last:border-b-0 animate-pulse">
      <div className="h-6 bg-gray-700 rounded w-full mb-2"></div>
      <div className="h-4 bg-gray-700 rounded w-1/2"></div>
    </li>
  );

  const renderCategoryListItemSkeleton = () => (
    <li className="pb-3 border-b border-border-subtle last:border-b-0 animate-pulse">
      <div className="h-6 bg-gray-700 rounded w-3/4"></div>
    </li>
  );

  const skeletons = [];
  for (let i = 0; i < count; i++) {
    if (type === 'project-card') {
      skeletons.push(<React.Fragment key={i}>{renderProjectCardSkeleton()}</React.Fragment>);
    } else if (type === 'blog-card') {
      skeletons.push(<React.Fragment key={i}>{renderBlogCardSkeleton()}</React.Fragment>);
    } else if (type === 'recent-blog-item') {
      skeletons.push(<React.Fragment key={i}>{renderRecentBlogListItemSkeleton()}</React.Fragment>);
    } else if (type === 'category-item') {
      skeletons.push(<React.Fragment key={i}>{renderCategoryListItemSkeleton()}</React.Fragment>);
    } else {
      skeletons.push(<div key={i} className="h-10 bg-gray-700 rounded animate-pulse"></div>);
    }
  }

  return <>{skeletons}</>;
}

export default SkeletonLoader;